import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      redirect: "Login",
      hidden: true
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("../views/login/Index.vue"),
      hidden: true
    },
    {
      path: "/protocol",
      name: "Protocol",
      component: () => import("../views/mail/Protocol.vue"),
      hidden: true
    },
    {
      path: "/emptyH",
      name: "EmptyH",
      component: () =>
        import("../layout/Index.vue"),
      hidden: true,
      children: [{
        path: "/empty",
        name: "Empty",
        component: () =>
          import("../views/empty/Index.vue")
      }]
    },
    {
      path: "/overview",
      name: "Overview",
      meta: {
        default_icon: 'i-ov.png',
        active_icon: 'i-ov-a.png'
      },
      component: () => import("../layout/Index.vue"),
      children: [
        {
          path: "index",
          name: "OverviewIndex",
          meta: { title: 'aside.overview' },
          component: () => import("../views/overview/Index.vue")
        }
      ]
    },
    {
      path: "/patient",
      name: "Patient",
      meta: {
        default_icon: 'i-ps.png',
        active_icon: 'i-ps-a.png'
      },
      component: () => import("../layout/Index.vue"),
      children: [
        {
          path: "index",
          name: "PatientIndex",
          meta: { title: 'aside.myPatients' },
          component: () => import("../views/patient/Index.vue")
        },
        {
          path: "details",
          name: "PatientDetails",
          meta: { title: "我的患者", level: 'secondary' },
          component: () => import("../views/patient/Details.vue")
        }
      ]
    },
    {
      path: "/invite",
      name: "Invite",
      meta: {
        default_icon: 'i-ic.png',
        active_icon: 'i-ic-a.png'
      },
      component: () => import("../layout/Index.vue"),
      children: [
        {
          path: "index",
          name: "InviteIndex",
          meta: { title: 'aside.inviteCodes' },
          component: () => import("../views/invite/Index.vue")
        }
      ]
    },
    {
      path: "/user",
      name: "User",
      meta: {
        default_icon: 'i-if.png',
        active_icon: 'i-if-a.png'
      },
      component: () => import("../layout/Index.vue"),
      children: [
        {
          path: "index",
          name: "UserIndex",
          meta: { title: 'aside.personalInfo' },
          component: () => import("../views/user/Index.vue")
        }
      ]
    },
    {
      path: "/sys",
      name: "System",
      component: () => import("../layout/OnlyFooter.vue"),
      hidden: true,
      children: [
        {
          path: "active",
          name: "Active",
          component: () => import("../views/system/Active.vue")
        },
        {
          path: "reset",
          name: "Reset",
          component: () => import("../views/system/Reset.vue")
        }
      ]
    },
    {
      path: "/support",
      name: "Support",
      component: () => import("../layout/OnlyFooter.vue"),
      hidden: true,
      children: [
        {
          path: "index",
          name: "SupportIndex",
          component: () => import("../views/support/Index.vue")
        },
        {
          path: "addNotesM",
          name: "AddNotesM",
          component: () => import("../views/support/AddNotesM.vue")
        },
        {
          path: "getStart",
          name: "GetStart",
          component: () => import("../views/support/GetStart.vue")
        },
        {
          path: "installAndUseM",
          name: "InstallAndUseM",
          component: () => import("../views/support/InstallAndUseM.vue")
        },
        {
          path: "informationM",
          name: "InformationM",
          component: () => import("../views/support/InformationM.vue")
        },
        {
          path: "overviewWC",
          name: "OverviewWC",
          component: () => import("../views/support/OverviewWC.vue")
        },
        {
          path: "instructionWP",
          name: "InstructionWP",
          component: () => import("../views/support/InstructionWP.vue")
        },
        {
          path: "uploadW",
          name: "UploadW",
          component: () => import("../views/support/UploadW.vue")
        },
        {
          path: "signUp",
          name: "SignUp",
          component: () => import("../views/support/SignUp.vue")
        },
        {
          path: "supportM",
          name: "SupportM",
          component: () => import("../views/support/SupportM.vue")
        },
        {
          path: "uploadDataM",
          name: "UploadDataM",
          component: () => import("../views/support/UploadDataM.vue")
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js